import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" eyebrow="Avant de vous décider" title="Questions fréquentes" data-id="element-45" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-3xl space-y-3" data-id="element-46" data-mp="1gausje4is4ki">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200" data-id="element-47" data-mp="292ehlensscuf" data-mpi={index}>
              <h3 data-id="element-48" data-mp="1z3714ilro233">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-pink-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-pink-200 md:px-7" data-id="element-49" data-mp="1z3yo551asrhr">
                  <span className="text-lg font-extrabold tracking-tight text-neutral-800" data-id="element-50" data-mp="ufpsucxenlxk">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-pink-700 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-51" data-mp="kiuvvygs5tle" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-52" data-mp="3sywrmbupimgt">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-53" data-mp="3swtr2xvxhaxu">
                    <p className="px-5 pb-6 text-lg leading-relaxed text-neutral-500 md:px-7" data-id="element-54" data-mp="1uhw9ey2u0mo4">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}